




import Vue from 'vue';
import AffiliationCodeConversion from '@/components/affiliation-code-conversion/affiliation-code-conversion.component.vue';
export default Vue.extend({
  components: {
    'affiliation-code-conversion': AffiliationCodeConversion
  }
});
